import { render, staticRenderFns } from "./SearchBlock.vue?vue&type=template&id=6f431af7&scoped=true&"
import script from "./SearchBlock.vue?vue&type=script&lang=js&"
export * from "./SearchBlock.vue?vue&type=script&lang=js&"
import style0 from "./SearchBlock.vue?vue&type=style&index=0&id=6f431af7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f431af7",
  null
  
)

export default component.exports